import { Button, Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";

import { faChevronLeft, faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { routes } from "../../constants";

export const NotAllowed = () => {
	const { orgId } = useParams() as { orgId: string };

	return (
		<main>
			<section className="vh-100 d-flex align-items-center justify-content-center">
				<Container>
					<Row className="align-items-center">
						<Col
							xs={12}
							lg={12}
							className="order-2 order-lg-1 text-center"
						>
							<h1 className="text-primary mt-5">
								<FontAwesomeIcon
									icon={faLock}
									className="me-3"
								/>
								403: Access Denied
							</h1>
							<p className="lead my-4">
								Sorry you're not permitted to access this
							</p>
							<Link
								to={
									orgId
										? `/org/${orgId}`
										: routes.presentation.path
								}
							>
								<Button
									variant="primary"
									className="animate-hover"
								>
									<FontAwesomeIcon
										icon={faChevronLeft}
										className="animate-left-3 me-3 ms-2"
									/>
									Go back home
								</Button>
							</Link>
						</Col>
					</Row>
				</Container>
			</section>
		</main>
	);
};
